var siteLaunchTheme = {
  siteLaunch: {
    bgStart: '#ffffff',
    bgEnd: '#ffffff',
    logo: {
      width: 190
    },
    callToActions: {
      paddingV: 0,
      callToAction: {
        paddingV: 4,
        paddingH: 8
      }
    }
  }
};
export default siteLaunchTheme;